<template>
	<div class="variant" :class="{active: cartItem}">
		<div class="content">
			<div class="title" v-text="description"/>
			<div class="sku" v-text="sku"/>
			<div class="price" v-text="price"/>
		</div>

		<counter v-bind="{props: {rules, productId: product_id, variantId: id}}"/>
	</div>
</template>

<script>
import counter from "@/components/counter/full.vue";

export default {
	components: {counter},
	props: {
		description: {type: String, required: true},
		product_id: {type: Number, required: true},
		rules: {type: Object, required: true},
		price: {type: Number, required: true},
		sku: {type: String, required: true},
		id: {type: Number, required: true}
	},
	computed: {
		cartProduct: (t) => t.$store.getters["cart/products"].find(x => x.id === t.product_id),
		cartItem: (t) => t.cartProduct ? t.cartProduct.line_items.find(x => x.variant_id === t.id) : null
	}
};
</script>

<style  lang="scss" scoped>
.variant {
	margin-bottom: 1px;
	position: relative;
	color: #272727;
	background-color: #f9fafb;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	font-weight: 300;
	padding: 12px 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.content {
		.title {
			font-size: 14px;
		}
		.sku {
			font-size: 12px;
			color: #303C49;
			opacity: 0.6;
			margin: 8px 0;
		}
	}
}
</style>
